import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { IsAdmin, IsArtist, IsTheaterAdmin } from '../../utils/Roles';
import GetTheaterId from '../../utils/GetTheaterId';
import GetEnabledStats from '../../utils/GetEnabledStats';
import Authorization from '../Authorization';
import { VENUES_PLAN } from '../../constants';

class Sidebar extends React.Component {
  logout() {
    localStorage.removeItem('escenaToken');
    localStorage.removeItem('escenaRole');
    localStorage.removeItem('escenaTheater');
    localStorage.removeItem('escenaStats');
    localStorage.removeItem('escenaPlan');

    this.props.onLogout(true);
  }

  render() {
    const { active } = this.props;

    const theaterId = GetTheaterId();
    const isAdmin = IsAdmin();
    const isTheaterAdmin = IsTheaterAdmin();
    const isArtist = IsArtist();
    const enabledStats = GetEnabledStats();

    return (
      <div className="my-account-box">
        {(isAdmin || isTheaterAdmin) && (
          <div className="item">
            <h3 className="title">Mantenedores</h3>
            <p>
              <Link
                to={
                    theaterId && isTheaterAdmin
                      ? `/admin/theater/${theaterId}`
                      : '/admin/theaters'
                  }
                className={active === 'theaters' ? 'active' : ''}
              >
                <i className="flaticon-social" /> Teatros
              </Link>
            </p>
            <p>
              <Authorization deniedPlans={[VENUES_PLAN]} >
                <Link
                  to="/admin/productions"
                  className={active === 'productions' ? 'active' : ''}
                >
                  <i className="flaticon-shape" /> Producciones
                </Link>
              </Authorization>
            </p>
            {(isTheaterAdmin && enabledStats) && (
              <p>
                <Link
                  to="/admin/analytics"
                  className={active === 'analytics' ? 'active' : ''}
                >
                  <i className="flaticon-monitor" /> Analiticas
                </Link>
              </p>
            )}
            {isAdmin && (
            <Fragment>
              <p>
                <Link
                  to="/admin/artists"
                  className={active === 'artists' ? 'active' : ''}
                >
                  <i className="flaticon-shape" /> Artistas
                </Link>
              </p>
              <p>
                <Link
                  to="/admin/users"
                  className={active === 'users' ? 'active' : ''}
                >
                  <i className="flaticon-shape" /> Usuarios
                </Link>
              </p>
              <p>
                <Link
                  to="/admin/mailer"
                  className={active === 'mailer' ? 'active' : ''}
                >
                  <i className="fa fa-envelope-o" /> Correos masivos
                </Link>
              </p>
              <p>
                <Link
                  to="/admin/newsletter"
                  className={active === 'newsletter' ? 'active' : ''}
                >
                  <i className="fa fa-envelope-o" /> Newsletter
                </Link>
              </p>
              <p>
                <Link
                  to="/admin/configurations"
                  className={active === 'configurations' ? 'active' : ''}
                >
                  <i className="fa fa-picture-o" /> Configuraciones
                </Link>
              </p>
            </Fragment>
              )}
          </div>
        )}
        {(isArtist && enabledStats) && (
          <div className="item">
            <p>
              <Link
                to="/artist-profile/analytics"
                className={active === 'analytics' ? 'active' : ''}
              >
                <i className="flaticon-monitor" /> Analiticas
              </Link>
            </p>
          </div>
        )}
        <div className="item">
          <h3 className="title">Mi cuenta</h3>
          <p>
            <Link
              to="/me/edit"
              className={active === 'personal' ? 'active' : ''}
            >
              <i className="flaticon-apartment" /> Información personal
            </Link>
          </p>
          <p>
            <Link
              to="/me/favorites"
              className={active === 'favorites' ? 'active' : ''}
            >
              <i className="fa fa-heart-o" /> Mis favoritos
            </Link>
          </p>
        </div>
        <div className="item">
          <p>
            <Link
              to="/me/password"
              className={active === 'password' ? 'active' : ''}
            >
              <i className="flaticon-security" /> Cambiar contraseña
            </Link>
          </p>
          <p>
            <a onClick={() => this.logout()}>
              <i className="flaticon-sign-out-option" /> Salir
            </a>
          </p>
        </div>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  active: '',
  onLogout: () => {},
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js